import { render, staticRenderFns } from "./ManageProductsPackagePlus.vue?vue&type=template&id=08b471f7"
import script from "./ManageProductsPackagePlus.vue?vue&type=script&lang=js"
export * from "./ManageProductsPackagePlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports